import { Outlet } from 'react-router-dom'
import { Nav } from './Nav'
import { Footer } from './Footer'
import { SkipToContent } from './SkipToContent'
import { ConsentBanner } from '@/analytics/ConsentBanner'

export function Layout() {
  return (
    <>
      <SkipToContent />
      <Nav />
      <main id="main">
        <Outlet />
      </main>
      <Footer />
      <ConsentBanner />
    </>
  )
}
